module.exports = __webpack_public_path__ + "static/media/food-carton-exterior.e08df25e.png";